/*
 * Return string normalized.
 * Look at the function and see
 */

const normalizeString = string => {
  return string
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
};

export { normalizeString };
